export default __webpack_public_path__ + "static/media/band_of_power.08b10b91.jpg";